module.exports = __webpack_public_path__ + "assets/f441177fff152e6de7ad1d366b1ec7ad.mp3";